import '../styles/NotreDamePrivacyPolicy.css';
function NotreDamePrivacyPolicy() {
    return (
        <div>
            At all home games for the Notre Dame Men’s Basketball team, if the opposing team misses two consecutive free throws in the second half only, all game attendees will win a free Nachos from Legend’s. Game attendees can bring their email into Legend’s and redeem it for a free nachos. This offer is valid up to 7 days after the game in which the team missed their two consecutive free throws. Guests can redeem the offer in the restaurant. Offer only valid on regular Nachos.*
            <br/>
            <br/>
            Offer includes one (1) free regular Nachos.  Not valid with any other offers, discounts, or special promotions. One offer per customer per order.  One time use. No cash value. Tax not included.  To redeem at the restaurant, present your email to your server when ordering.  Void where prohibited. Offer must be used within seven days hours after the end of the game where the promotion was activated.
        </div>
    );
}

export default NotreDamePrivacyPolicy;
